jQuery(document).ready(function($) {
  new WOW().init();

    $(".plus-btn").each(function() {
      var wowHeight = $(this).height();
      $(this).attr("data-wow-offset", wowHeight);
    });

    $(".cat-wrap").each(function() {
      var wowHeight = $(this).height();
      $(this).attr("data-wow-offset", wowHeight);
    });

    var btnwow = new WOW(
      {
        boxClass:     'plus-btn', 
        animateClass: 'animated',
      }
    );
    btnwow.init();


	$('.home-slider').slick({
	  infinite: true,
	  slidesToShow: 1,
	  dots: true,
    prevArrow: false,
    nextArrow: false,
    adaptiveHeight: true
	});

	$('.cat-select__tabs .tab').click(function() {
    var related = $(this).attr("data-active");
    $(".cat-select__tabs .tab").not(this).removeClass("active");
    $(this).addClass('active');
    $('.hire-sales .cat-wrap .cat-select__featured .item').removeClass('active');
    $('.hire-sales .cat-wrap .cat-select__featured .item[data-active="'+related+'"]').addClass('active');
  });

  $('.service-table__row__column--model').click(function() {
    $(".service-table-wrap .service-table__row").not($(this).parent()).removeClass("active");
    $(this).parent().toggleClass('active');
  });
 

  $('.service-enquire-btn').click(function() {
    var subject = $(this).attr("data-enquire-subject");
    $(".enquiry-subject").val(subject);
    $(".page-template-service .remodal.enquire-modal .title .model").text(subject);
  });

  $('.filter-selected').click(function() {
    event.stopPropagation();
    $('.range-filter__drop').toggleClass('active');
    $('.service-table__body').toggleClass('blur');
  });


  $('.approved-modal__inner .content .enquire').click(function() {
    var subject = $(this).attr("data-enquire-subject");
    $(".enquiry-subject").val(subject);
    
    $(this).parent().parent().addClass('show-form');
  });

  $('.approved-modal .remodal-close').click(function() {
    $(this).parent().find('.approved-modal__inner').removeClass('show-form');
  });

  

  $(document).click( function(){
    $('.range-filter__drop').removeClass('active');
    $('.service-table__body').removeClass('blur');
  });

  $('.range-filter__drop .filter-option').click(function() {
    $(".service-table-wrap .service-table__row").removeClass("active");

    var min = parseFloat($(this).attr("data-weight-min"));
    var max = parseFloat($(this).attr("data-weight-max"));
  
    if(max == '0') {
      $(".service-table__row--body").removeClass('filter-hide');
      $('.filter-selected').text('No Filter');
    } else {
      $('.filter-selected').text(min + '.0 - ' + max + '.0 TON');

      $(".service-table__row--body").each(function() {
        var rowmin = parseFloat($(this).attr("data-weight-min"));
        var rowmax = parseFloat($(this).attr("data-weight-max"));
        // console.log(rowmax + ' < ' + max);
        if((rowmin <= max) && (rowmax >= min)) {
          $(this).removeClass('filter-hide');
        } else {
          $(this).addClass('filter-hide');
        }
      });
    }
  });

  $(".service-scroll").click(function() {
    var target = $(".service-table-wrap");
    $('html,body').animate({
      scrollTop: $(".service-table-wrap").offset().top},
    1000);
});


  $(".plus-btn").each(function() {
      var wowHeight = $(this).height();
      $(this).attr("data-wow-offset", wowHeight);
    });

  $( ".header__nav #menu-header-menu > li.has-mega-menu" ).hover(function() {
    $('.supreme-container').toggleClass('menu-open');
  });

  $('.page-link-blocks .page-link__inner p.title').each(function(){
    var me = $(this);
    me.html( me.text().replace(/(^\w+)/,'<span>$1</span><br>') );
  });

  $('.service-title').html(function(){
    var text= $(this).text().split(' ');
    // drop the last word and store it in a variable
    var last = text.pop();
    // join the text back and if it has more than 1 word add the span tag
    // to the last word
    return text.join(" ") + (text.length > 0 ? ' <br><span>'+last+'</span>' : last);   
  });

  $('.cv-file-upload').change(function() {
    $('.wpcf7-form .cv-wrap .cv-text').text($(this).val());
  })

  $('.partners-slider').slick({
    infinite: true,
    slidesToShow: 6,
    dots: false,
    prevArrow: false,
    nextArrow: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5
        }
      },

      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 460,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  function mobile_menu() {
    var checkWidth = $(window).width();
    if (checkWidth < 992) {
      /* ====================== Mobile Menu accordion ======================  */
      $(".header__nav #menu-header-menu > .menu-item-has-children").on("click", function(event) {
        $(".header__nav #menu-header-menu > .menu-item-has-children").find('> a').removeClass('active');
        $('.header__nav #menu-header-menu > .menu-item-has-children > .sub-menu').slideUp();
        $(this).find('> a').addClass('active');
        $(this).children().find('> .sub-menu').slideDown();
        $(this).find('.mega-menu-wrap .container .mega-menu > .sub-menu').slideDown();
      });

      $(".header__nav #menu-header-menu > li .sub-menu > .menu-item-has-children").on("click", function(event) {
        $(".header__nav #menu-header-menu > li .sub-menu > .menu-item-has-children").find('> a').removeClass('active');
        $('.header__nav #menu-header-menu > li .sub-menu > .menu-item-has-children > .sub-menu').not($(this).find('> .sub-menu')).slideUp();
        $(this).find('> a').addClass('active');
        $(this).find('> .sub-menu').slideDown();
      });
    }
  }

  mobile_menu();

  $(window).resize(function(){
    mobile_menu();
  });

  /* ====================== Mobile Menu Trigger ======================  */

  $('.nav-trigger').click(function(){
    $('.header__nav').toggleClass('open');
    $(".header__nav #menu-header-menu .menu-item-has-children").find('> a').removeClass('active');
    $('.header__nav #menu-header-menu .menu-item-has-children .sub-menu').slideUp();
    $(this).toggleClass('open');
    $('.header__top').not('.active').toggleClass('active');
  });

  $(window).scroll(function() {
      if ($(this).scrollTop() > 0) {
        $('.header__top').addClass('active');
      } else {
        $('.header__top').removeClass('active');
      }
  });

  /* ====================== Approved Used Horizontal Scrolling ======================  */
  function kinetic() {
    var checkWidth = $(window).width();
    if (checkWidth > 1200) {
      $('.approved-used__wrap').kinetic({
          cursor: 'pointer',
          slowdown: 0.96,
          threshold: 60,
          filterTarget: function(target, e){
              if (!/down|start/.test(e.type)){
                  return !(/area|a|input/i.test(target.tagName));
              }
          },
      });
    } else {

    }
  };

  kinetic();

  $(window).resize(function(){
    kinetic();
  });

  /* ====================== Fix quick message on approved used ======================  */
    $.fn.followTo = function (pos) {
      var $this = this,
          $window = $(window);

      $window.scroll(function (e) {
          if ($window.scrollTop() > pos) {
              $this.css({
                  position: 'absolute',
                  top: 'calc(30vh + ' + pos + 'px)'
              });
          } else {
              $this.css({
                  position: 'fixed',
                  top: '30%'
              });
          }
      });
  };

  if($('.approved-used').length > 0) {
    var elementTop = $('.approved-used').offset().top - $('.approved-used').height() - 20;
  }

  $('.quick-message').followTo(elementTop);


  /* ====================== Approved used Slider ======================  */
   $(document).on('opened', '.remodal.has-slider', function () {
    var $this = $(this);
    setTimeout(function() {
      $this.removeClass("loading");
    }, 300);

    var imageSlider = $(this).find('.approved-modal-image-slider');

    imageSlider.not('.slick-initialized').slick({
      slidesToShow: 1,
      dots: false,
      prevArrow: '<span class="prev"></span>',
      nextArrow: '<span class="next"></span>',
    });
  });

    

}); 
